import React from 'react';
import PropTypes from 'prop-types';

const FallbackAvatar = ({ size, ...rest }) => (
  <svg {...rest} width={size} height={size} viewBox="0 0 181 181" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <filter id="fallbackAvatarFilter">
        <feColorMatrix in="SourceGraphic" type="matrix" values="0 0 0 0 0.847000 0 0 0 0 0.847000 0 0 0 0 0.847000 0 0 0 1.000000 0" />
      </filter>
    </defs>
    <g id="Final" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="circleuseralt" transform="translate(-481.000000, -389.000000)" filter="url(#fallbackAvatarFilter)">
        <g transform="translate(481.000000, 389.000000)">
          <path d="M90.5,181 L90.5,181 C40.5183583,181 0,140.481642 0,90.5 C0,40.5183583 40.5183583,0 90.5,0 C140.481642,0 181,40.5183583 181,90.5 L181,90.5 C181,140.481638 140.481642,181 90.5,181 L90.5,181 Z M90.504906,33.9752083 C70.260056,33.9752083 56.5526998,49.6000333 56.5526998,70.3437646 C56.5526998,94.4393896 72.381904,109.40545 90.504906,109.40545 C108.627908,109.40545 124.457112,94.4390125 124.457112,70.3437646 C124.457112,49.6004104 110.749379,33.9752083 90.504906,33.9752083 Z M90.504906,120.652715 C65.5487769,120.652715 48.5834206,129.36334 39.1193831,140.696956 L39.119383,140.696956 C37.8039315,142.225811 37.9130481,144.516283 39.3678812,145.91315 L39.3678766,145.913146 C68.2415245,172.585758 112.767147,172.583798 141.638533,145.908629 L141.638533,145.90863 C143.093324,144.51163 143.202116,142.22103 141.886277,140.692436 C132.421108,129.359196 115.458014,120.652715 90.5041474,120.652715 L90.504906,120.652715 Z" id="Shape" fill="#000000" />
        </g>
      </g>
    </g>
  </svg>
);

FallbackAvatar.propTypes = {
  size: PropTypes.string,
};

FallbackAvatar.defaultProps = {
  size: '24px'
};

export default FallbackAvatar;
